import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ActivatedRoute, Router } from '@angular/router';

import { PurchaseOrderService } from '../../services/purchase-order.service';
import { PurchaseRequestService } from '../../services/purchase-request.service';
import { PrCmpa, ProductCmpaService } from '../../services/product-cmpa.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { ProductionOrderService } from '../../services/production-order.service';
import { UnitService } from '../../services/unit.service';
import { CatalogsSettingsService, PayrollId } from '../../services/catalogs-settings.service';

import { Observable } from 'rxjs/Observable';
import { Utils } from '../../util';

import { ISubscription, Subscription } from "rxjs/Subscription";
import { DISABLED } from '@angular/forms/src/model';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { CustomerBillData } from '../../services/customer-bill.service';
import { SelectOption } from '../../globals';

@Component({
  selector: 'app-create-purchase-order',
  templateUrl: './create-purchase-order.component.html',
  styleUrls: ['./create-purchase-order.component.css']
})
export class CreatePurchaseOrderComponent implements OnInit, OnDestroy {
  
  onEdit: number = -1;

  prCmpaError: boolean = false;

  supplier: any = {
    id: '',
    name: '',
    email: '',
    fiscalId: '',
    fiscalName: ''
  };
  purchaseRequestId: string;
  purchaseRequest: {};

  subTotal: number = 0;
  ivaTotal: number = 0;
  total: number = 0;
  
  units = {};

  modalActionsPrForOrder = new EventEmitter<string|MaterializeAction>();
  modalParamsPrForOrder = [{dismissible: true}];
  
  purchaseOrderForm: FormGroup;
  prForOrderForm: FormGroup;
  currencySelect: SelectOption[] = [];

  //requestedFolio: number;
  settings: PayrollId;

  prForOrders = [];
  prFromReqs = [];

  prCmpas = {};

  prCmpasInit: any;
  
  prCmpasSub: Subscription;
  productionOrderSub: Subscription;
  purchaseReqSub: Subscription;
  supplierSub: Subscription;
  unitsSub: Subscription;

  pickadateParams = Utils.pickadateParams();

  constructor(
    private purchaseOrderService: PurchaseOrderService,
    private purchaseRequestService: PurchaseRequestService,
    private prCmpaService: ProductCmpaService,
    private supplierService: CustomerSupplierService,
    private fiscalDataService: FiscalDataService,
    private unitService: UnitService,
    private productionOrderService: ProductionOrderService,
    private settingsService: CatalogsSettingsService,
    private billData: CustomerBillData,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.createForm();
    this.createFormPrForOrder();
    this.purchaseOrderForm.get('date').patchValue(this.getDate());

    //Assign folio
    /* this.setSub = this.settingsService.getPayrollSettings('1').subscribe(settings => {
      let requesteds = settings.folios.purchaseOrderRequesteds || [];
      let lastFolio = settings.folios.purchaseOrder;
      this.settings = settings;
      if(!this.requestedFolio){
        this.requestedFolio = lastFolio + 1;
        while(requesteds.includes(this.requestedFolio)) this.requestedFolio++;
        this.purchaseOrderForm.get('folio').patchValue(this.requestedFolio);
        toast(`Se apartó el folio '${this.requestedFolio}' de configuración.`, 2000);
        console.log(`Se apartó el folio '${this.requestedFolio}' de configuración.`);
        requesteds.push(this.requestedFolio);
        settings.folios.purchaseOrderRequesteds = requesteds;
        this.settingsService.putPayrollSettings(<PayrollId>{folios: settings.folios}, '1');
      }
    }); */

    this.productionOrders = {};
    this.productionOrderSub = this.productionOrderService.getProductionOrders({lessStatus: 'key98'}).subscribe(productionOrders => {
      this.rowsRead[0] = productionOrders.map(({id$, ...productionOrder}) => {
        return this.productionOrders[id$] = {id: id$, ...productionOrder}; 
      });
    });

    let [supId, fiscalId] = this.activatedRoute.snapshot.paramMap.get('idSup').split('_');
    this.supplier.id = supId;
    this.supplier.fiscalId = fiscalId;
    this.supplierSub = this.supplierService.getCustomerSupplier(this.supplier.id).subscribe(supplier => {
      this.supplier.name = supplier.name;
      this.supplier.email = supplier.email;
      let fiscalSub = this.fiscalDataService.getFiscalData(this.supplier.fiscalId).subscribe(fiscalData => {
        fiscalSub.unsubscribe();
        this.supplier.fiscalName = fiscalData.businessName;
      });
    });
    this.unitsSub = this.unitService.getUnits().subscribe(units => {
      units.map(unit => {
        this.units[unit.id] = unit.symbol;
        this.units[`Name of: ${unit.id}`] = unit.name;
      });
    });


    this.purchaseRequestId = this.activatedRoute.snapshot.paramMap.get('idReq');
    if(this.purchaseRequestId != 'noReq'){
      this.purchaseReqSub = this.purchaseRequestService.getPurchaseRequest(this.purchaseRequestId).subscribe(([request]) => {
        this.purchaseReqSub.unsubscribe();
        this.purchaseRequest = request;
      });
      this.prFromReqs = JSON.parse(localStorage.reqPrCmpas);
      delete localStorage.reqPrCmpas;
      if(localStorage.odcLowestDate){
        this.purchaseOrderForm.get('deliveryRequiredDate').patchValue(localStorage.odcLowestDate);
        delete localStorage.odcLowestDate;
      }
      console.log(this.prFromReqs);
      Object.keys(this.prFromReqs).reduce((acc, cur) => [...acc, ...this.prFromReqs[cur].products], []).map(product => {
        let prCmpaSub = this.prCmpaService.getPrCmpa(product.id).subscribe(([prCmpa]) => {
          prCmpaSub.unsubscribe();
          let description = '';
          var cont = 0;
          prCmpa.characs.map(charact => {
            cont++;
            if(cont != 1){
              description += ', ';
            }
            description += charact.name + ': ' + charact.value + this.units[charact.unitId.id];
          })
          let characs = prCmpa.characs.reduce((acc, cur, index) => `${acc}${index ? ', ' : ''}${cur.name.charAt(0)} ${cur.value}${this.units[cur.unitId.id] ? ` ${this.units[cur.unitId.id]}` : ''}`, '');
          let prices = prCmpa.prices.filter(price => price.supplierId.id == this.supplier.id);
          let [{price:pricePerUnit=0, usesIva=false, amountIva=0}={}] = prices.length ? prices : prCmpa.prices;
          //let price = prCmpa.prices.filter(price => price.supplierId.id == this.supplier.id)[0] || undefined;
          const amount = pricePerUnit * product.quantity;
          const value = {
            id: product.id,
            amount: amount,
            amountIva,
            code: prCmpa.code,
            description: description,
            name: `${prCmpa.name}${ characs ? ` - ${characs}` : ''}`,
            customName: `${prCmpa.name}${ characs ? ` - ${characs}` : ''}`,
            pricePerUnit,
            quantity: product.quantity,
            unitName: this.units[`Name of: ${(prCmpa.unitRef || {id: 'null'}).id}`] || '',
            usesIva,
            odpId: product.odpId,
            odpName: '',
            customerName: ''
          }
          if(product.odpId) var sub = productionOrderService.getProductionOrder(product.odpId).subscribe(([{name, customer:{cName=''}={}}]) => {sub.unsubscribe(); value.odpName = name; value.customerName = cName })
          this.prForOrders.push(value);
          this.displayTotals();
        });
      });
    }
    
    this.getPrCmpas();
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    if(this.productionOrderSub) this.productionOrderSub.unsubscribe();
    if(this.supplierSub) this.supplierSub.unsubscribe();
    if(this.unitsSub) this.unitsSub.unsubscribe();
    if(this.prCmpasSub) this.prCmpasSub.unsubscribe();
    window.onbeforeunload = null;
  }

  async onSubmit({ value, valid }: { value: any, valid: boolean }) {
    if(!this.prForOrders.length) return toast('No hay productos.', 3000);
    if(!this.prForOrders.reduce((acc, cur) => acc && cur.amount, true)) return toast('Falta asignar precios a productos.', 3000);
    value.prForOrders = this.prForOrders.map((pr, prIndex) => ({ uniqueId: `${Utils.String.fillLeft(`${prIndex}`, '0', 3)}${Utils.randomString(3)}`, ...pr }));
    value.subTotal = this.subTotal;
    value.ivaTotal = this.ivaTotal;
    value.total = this.total;
    value.supplierId = this.supplier.id;
    value.fiscalDataId = this.supplier.fiscalId;
    
    value.folio = await this.settingsService.getNextFolioAndIncrement('purchaseOrder');
    let docId = this.purchaseOrderService.addPurchaseOrder(value);
    let updatedPrCmpaIds: string[] = [];
    this.prForOrders.map(pr => {
      if(!pr.id || updatedPrCmpaIds.includes(pr.id)) return;
      updatedPrCmpaIds.push(pr.id);
      this.prCmpaService.updatePrCmpa(pr.id, {lastPriceUsed: pr.pricePerUnit});
    });
    if(this.purchaseRequestId != 'noReq'){
      Object.keys(this.prFromReqs).map(reqId => {
        let sub = this.purchaseRequestService.getPurchaseRequest(reqId).subscribe(([{productsInRequest}]) => {
          sub.unsubscribe();
          console.log(this.prFromReqs)
          this.prFromReqs[reqId].products.map(pr => {
            productsInRequest[pr.index].ordered = true;
          });
          let ordered = productsInRequest.every(({ordered}) => ordered);
          this.purchaseRequestService.updatePurchaseRequest(reqId, {productsInRequest, ordered});
        });
      });
      this.router.navigate([`/vw_purchase_order/${docId}/fromReq`]);
    }else{
      this.router.navigate([`/vw_purchase_order/${docId}/fromOrder`]);
    }
  }
  /* async returnRequested(){
    let requestedIndex = this.settings.folios.purchaseOrderRequesteds.indexOf(this.requestedFolio);
    if(requestedIndex > -1){
      this.settings.folios.purchaseOrderRequesteds.splice(requestedIndex, 1);
      await this.settingsService.putPayrollSettings(<PayrollId>{folios: this.settings.folios}, '1');
    }
    //this.service.windowReplace('read');
    //window.onbeforeunload = null;
  }
  updateSettings(){
    let requestedIndex = this.settings.folios.purchaseOrderRequesteds.indexOf(this.requestedFolio);
    if(requestedIndex > -1){
      this.settings.folios.purchaseOrderRequesteds.splice(requestedIndex, 1);
    }
    if(this.requestedFolio > this.settings.folios.purchaseOrder) this.settings.folios.purchaseOrder = this.requestedFolio;
    this.settingsService.putPayrollSettings(this.settings, '1');
  } */

  getPrCmpas() {
    this.prCmpasSub && this.prCmpasSub.unsubscribe();
    this.prCmpasSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {
      prCmpas.map(prCmpa => {
        prCmpa.prices = prCmpa.prices.filter(price => !price.supplierId || price.supplierId.id == this.supplier.id);
      });
      
      const data = prCmpas.reduce((acc, cur) => {
        let characs = cur.characs.reduce((acc2, cur2, index) => `${acc2}${index ? ', ' : ''}${cur2.name.charAt(0)} ${cur2.value}${this.units[cur2.unitId.id] ? ` ${this.units[cur2.unitId.id]}` : ''}`, '');
        acc[`${cur.name}${ characs ? ` - ${characs}` : ''}`] = null;
        this.prCmpas[`${cur.name}${ characs ? ` - ${characs}` : ''}`] = cur.id;
        this.prCmpas[`Unit of: ${cur.name}${ characs ? ` - ${characs}` : ''}`] = cur.unitRef ? this.units[`Name of: ${cur.unitRef.id}`] : '';
        return acc;
      }, {});
      this.prCmpasInit = {
        'data': data
      }
    });
  }

  createForm() {
    this.currencySelect = this.billData.allSelects.currency;
    this.purchaseOrderForm = this.fb.group({
      deliveryRequiredDate: '',
      notes: '',
      date: '',
      currency: [this.currencySelect[0].value, Validators.required],
      change: [1, Validators.required],
    });
  }
  createFormPrForOrder() {
    this.prForOrderForm = this.fb.group({
      code: ['', Validators.required],
      name: ['', Validators.required],
      customName: ['', Validators.required],
      quantity: ['', Validators.required],
      unitName: '',
      pricePerUnit: ['', Validators.required],
      usesIva: [''],
      amountIva: [''],
      notes: '',
    });
  }

  onChangeCurrency(){
    if(this.purchaseOrderForm.get('currency').value == 'key0') this.purchaseOrderForm.get('change').patchValue(1);
    else this.prForOrders.map(pr => pr.usesIva = false);
  }

  addPrForOrder({ value, valid }: { value: any, valid: boolean }) {
    console.log(99, value.name);
    if(this.prCmpas[value.name] == undefined){
      this.prCmpaError = true;
      this.prForOrderForm.get('name').setValue('');
    }else{
      let prCmpaSub = this.prCmpaService.getPrCmpa(this.prCmpas[value.name]).subscribe(([prCmpa]) => {
        prCmpaSub.unsubscribe();
        value.id = this.prCmpas[value.name];

        value.description = '';
        var cont = 0;
        prCmpa.characs.map(charact => {
          cont++;
          if(cont != 1){
            value.description += ', ';
          }
          value.description += charact.name + ': ' + charact.value + this.units[charact.unitId.id];
        })

        value.amount = value.pricePerUnit * value.quantity;
        if(value.amountIva == undefined){
          value.amountIva = 0;
        }
        this.prForOrders.push(value);
        this.displayTotals();
      });
      this.closeModalPrForOrder();
    }
  }
  editPrForOrder({ value, valid }: { value: any, valid: boolean },index: number){
    if(this.prCmpas[value.name]){
      this.prForOrders[index].id = this.prCmpas[value.name]
    }else{
      this.prCmpaError = true;
      return;
    }
    if(value.amountIva == undefined || value.amountIva < 0){
      value.amountIva = 0;
    }

    this.prForOrders[index].name = value.name;
    this.prForOrders[index].code = value.code;
    this.prForOrders[index].customName = value.customName;
    this.prForOrders[index].quantity = value.quantity;
    this.prForOrders[index].pricePerUnit = value.pricePerUnit;
    this.prForOrders[index].usesIva = value.usesIva;
    this.prForOrders[index].amountIva = value.amountIva;
    this.prForOrders[index].amount = value.pricePerUnit * value.quantity;
    this.prForOrders[index].notes = value.notes || '';

    this.closeModalPrForOrder();
    this.displayTotals();
  }
  deletePrForOrder(index) {
    this.prForOrders.splice(index,1);
    this.displayTotals();
  }

  openModalPrForOrder(index: number) {
    this.onEdit = index;
    this.prForOrderForm.reset();
    this.prCmpaError = false;
    if(index == -1){
      this.prForOrderForm.get('usesIva').patchValue(false);
    }else{
      this.prForOrderForm.get('code').setValue(this.prForOrders[index].code);
      this.prForOrderForm.get('name').setValue(this.prForOrders[index].name);
      this.prForOrderForm.get('customName').setValue(this.prForOrders[index].customName);
      this.prForOrderForm.get('quantity').setValue(this.prForOrders[index].quantity);
      this.prForOrderForm.get('pricePerUnit').setValue(this.prForOrders[index].pricePerUnit);
      this.prForOrderForm.get('usesIva').setValue(this.prForOrders[index].usesIva);
      this.prForOrderForm.get('amountIva').patchValue(this.prForOrders[index].amountIva);
      this.prForOrderForm.get('notes').patchValue(this.prForOrders[index].notes);
    }
    this.modalActionsPrForOrder.emit({ action: 'modal', params: ['open'] });
  }
  closeModalPrForOrder() {
    this.modalActionsPrForOrder.emit({ action: 'modal', params: ['close'] });
  }

  displayTotals(){
    var subTotal = 0;
    var ivaTotal = 0;
    this.prForOrders.map(item => {
      subTotal += item.amount;
      if(item.usesIva){
        ivaTotal += (item.amount * (item.amountIva / 100));
      }
    });
    var total = subTotal + ivaTotal;
    
    this.subTotal = +subTotal.toFixed(2);
    this.ivaTotal = +ivaTotal.toFixed(2);
    this.total = +total.toFixed(2);
  }

  suggestData(){
    const productName = this.prForOrderForm.get('name').value;
    let prCmpaId = this.prCmpas[productName];
    if(!prCmpaId) return toast('Escriba un producto válido.', 3000);
    this.prForOrderForm.get('customName').patchValue(productName);
    
    let prCmpaSub= this.prCmpaService.getPrCmpa(prCmpaId).subscribe(([prCmpa]) => {
      prCmpaSub.unsubscribe();
      let prices = prCmpa.prices.sort(({currency='key0'}) => currency == this.purchaseOrderForm.get('currency').value ? -1 : 1).sort(({supplierId}) => supplierId.id == this.supplier.id ? -1 : 1);
      let [{price=0, usesIva=false, amountIva=0}={}] = (prices.length ? prices : prCmpa.prices).sort(({price: p1}, {price: p2}) => p2 - p1);
      console.log(prCmpa);
      this.prForOrderForm.get('code').setValue(prCmpa.code);
      this.prForOrderForm.get('pricePerUnit').setValue(price);
      this.prForOrderForm.get('usesIva').setValue(usesIva);
      this.prForOrderForm.get('amountIva').patchValue(amountIva);
      this.prForOrderForm.get('unitName').patchValue(this.prCmpas[`Unit of: ${productName}`] || '');
    });
  }

  getDate(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

  ceroes(number:string){
    if(number.length < 5){
      return this.ceroes('0' + number);
    }else{
      return number;
    }
  }

  getBack() {
    if(this.purchaseRequestId != 'noReq'){
      this.router.navigate(['/order_purchase_request']);
    } else {
      this.router.navigate(['/purchase_order']);
    }
  }



  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 

  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  
  //ProductionOrder
  productionOrders: any = {};
  currentPrIndex: number = -1;

  currentReadIndex: number;
  rowsRead = [[]];
  columnsRead = [
    [
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'status' }
    ]
  ]

  openModalRead(index: number, prIndex: number) {
    this.currentReadIndex = index;
    this.currentPrIndex = prIndex;
    this.data = this.rowsRead[index];
    
    this.config = this.configs[index];
  
    this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead({row: odp}): any{
    this.prForOrders[this.currentPrIndex].odpId = odp.id;
    this.prForOrders[this.currentPrIndex].odpName = odp.name;
    this.prForOrders[this.currentPrIndex].customerName = odp.customer && odp.customer.name || '';
    this.closeModalRead();
  }


  data:Array<any>;
  rows:Array<any> = [];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config;
  configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns},
    filtering: {filterString: ''}
  }));

  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA
  
}
